import Common from '../Common/Constants'
import AddMember from './AddMember'
import MemberDetailDialog from './MemberDetailDialog'
import AlertModal from '../Common/AlertModal'
import ProgressDialog from '../Common/ProgressDialog'
import UploadStatusDialog from '../Common/UploadStatusDialog'
import axios from "axios/index";

export default {
    name: "MemberDetails",
    components: {AddMember, AlertModal, MemberDetailDialog, ProgressDialog, UploadStatusDialog},
    data() {
        return {
            header: {},
            constant: Common,
            search: '',
            searchReq: '',
            delDialog: false, delData: {},
            mask: '##### #####',
            headers: [
                {text: 'Name', align: '', sortable: true, value: 'name'},
                {text: 'Election ID', align: '', sortable: true, value: 'election_id'},
                {text: 'Email', align: '', sortable: false, value: 'email'},
                {text: 'D.O.B', align: '', sortable: false, value: 'dob'},
                {text: 'Primary Contact', align: '', sortable: false, value: 'primary_mobile'},
                {text: 'Secondary Contact', align: '', sortable: false, value: 'secondary_mobile'},
                {text: 'Registered in app ?', align: '', sortable: false, value: ''},
                {text: 'Actions', sortable: false, value: ''},
            ],
            headersJoinReq: [
                {text: 'Name', align: '', sortable: true, value: 'name'},
                {text: 'Election ID', align: '', sortable: true, value: 'election_id'},
                {text: 'D.O.B', align: '', sortable: false, value: 'dob'},
                {text: 'Primary Contact', align: '', sortable: false, value: 'primary_mobile'},
                {text: 'Actions', sortable: false, value: ''},
            ],
            headersView: [
                {text: 'Name', align: '', sortable: true, value: 'name'},
                {text: 'Election ID', align: '', sortable: true, value: 'election_id'},
                {text: 'Email', align: '', sortable: false, value: 'email'},
                {text: 'D.O.B', align: '', sortable: false, value: 'dob'},
                {text: 'Primary Contact', align: '', sortable: false, value: 'primary_mobile'},
                {text: 'Secondary Contact', align: '', sortable: false, value: 'secondary_mobile'},
                {text: 'Registered in app ?', align: '', sortable: false, value: ''},
            ],
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],
            memberDetails: [],
            memberRequest: [],
            loading: true,
            successToast: {
                theme: "primary",
                position: "top-right",
                duration: 3000,
                className: 'success-toast'
            },
            errorToast: {
                theme: "primary",
                position: "top-right",
                duration: 3000,
                className: 'error-toast'
            },
            memberFileName: '',
            memberFile: '',
            dialog: false,
            alertDialog: false,
            errorDialog: false,
            msg: '',
            club_details: {}, roleOfficers: [],
            addMemberDialog: false,
            editMember: {},
            addEditFlag: false, addFlag: false, detailFlag: false,
            requestFlag: false, editFlag: false, isVerifyCount: '',
            clubDetails: [],
            user: {},
            delReqDialog: false,
            uploadBtnFlag: false,
            uploadProgressPopup: false,
            uploadStatusPopup: false,
            successRecordArr: [],
            failRecordArr: [],

            searchVal: '',
            skip: 0, count: 25,
            totalCount: 12, totalPage: '', page: 1,
            pagiReqSkip: 0, pagiReqCount: 25,
            totalMemberReqCount: 0, totalReqPage: 0, reqPage: 1
        }
    },
    watch: {
        search: function (val) {
            this.searchVal = val;
            this.getMemberDetails()
        },
        searchReq: function (val) {
            this.searchVal = val;
            this.getMemberRequest()
        },
    },
    created() {
        let self = this;
        self.club_details = JSON.parse(localStorage.getItem('club_details'));
        self.user = JSON.parse(localStorage.getItem('user'));
        self.totalCount = self.club_details.memberVerifyCount;
        // self.totalMemberReqCount = 12;
        // self.totalMemberReqCount = self.club_details.member_count - self.club_details.memberVerifyCount;
        this.getMemberDetails();
        this.getMemberRequest();
    },
    methods: {
        /*getMemberCount() {
            let self = this;
            axios.get(self.constant.apiUrl + 'member/count/' + this.$route.params.id, {headers: self.header})
                .then(res => {
                        if (res.data.flag) {
                            self.totalCount = res.data.data;
                            self.getMemberDetails();
                        }
                        else {
                            self.$toasted.show('Club Not Found', self.errorToast)
                        }
                    }
                )
                .catch((handle) => {
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = handle;
                })
        },*/
        pagination(str) {
            let self = this;
            if (str == 'JoinReq') {
                self.pagiReqSkip = ((self.reqPage - 1) * self.pagiReqCount);
                self.getMemberRequest();
            }
            else {
                self.skip = ((self.page - 1) * self.count);
                self.getMemberDetails();
            }
        },
        getMemberDetails() {
            let self = this;
            let request = {
                "filters": {
                    "search": self.searchVal,
                },
                "sort": "created_at",
                "direction": "desc",
                "skip": self.skip,
                "count": self.count
            };
            if (self.search != '')
                request.skip = 0;
            axios.post(Common.apiUrl + 'club/getMembers/' + this.$route.params.id + '/allow', request)
                .then(res => {
                    if (res.data.flag) {
                        res.data.data.members.forEach(function (val) {
                            (val.mname == null || val.mname == '') ? val.name = val.fname + ' ' + val.lname :
                                val.name = val.fname + ' ' + val.mname + ' ' + val.lname;
                            // val.name = val.prefix + ' ' + val.fname + ' ' + val.mname + ' ' + val.lname;
                            val.primary_mobile = val.phone[0].phone;
                            val.secondary_mobile = val.phone.length == 2 ? val.phone[1].phone : '';
                        });
                        self.memberDetails = res.data.data.members;
                        self.totalCount = res.data.data.count;
                        self.totalPage = Math.ceil(self.totalCount / self.count);
                        self.loading = false
                    }
                    else {
                        self.loading = false
                        // self.$toasted.show('Member Not Found', self.errorToast)
                    }
                })
                .catch((handle) => {
                    self.$toasted.show(handle, self.errorToast);
                })
        },
        getMemberRequest() {
            let self = this;
            let request = {
                "filters": {
                    "search": self.searchVal,
                },
                "sort": "created_at",
                "direction": "desc",
                "skip": self.pagiReqSkip,
                "count": self.pagiReqCount
            };
            if (self.searchReq != '')
                request.skip = 0;
            axios.post(Common.apiUrl + 'club/getMembers/' + this.$route.params.id + '/pending', request)
                .then(res => {
                    if (res.data.flag) {
                        res.data.data.members.forEach(function (val) {
                            (val.mname == null || val.mname == '') ? val.name = val.fname + ' ' + val.lname :
                                val.name = val.fname + ' ' + val.mname + ' ' + val.lname;
                            // val.name = val.prefix + ' ' + val.fname + ' ' + val.mname + ' ' + val.lname;
                            val.primary_mobile = val.phone[0].phone;
                            val.secondary_mobile = val.phone.length == 2 ? val.phone[1].phone : '';
                        });
                        self.memberRequest = res.data.data.members;
                        self.totalMemberReqCount = res.data.data.count;
                        self.totalReqPage = Math.ceil(self.totalMemberReqCount / self.pagiReqCount);
                        self.loading = false
                    }
                    else {
                        self.loading = false
                        // self.$toasted.show('Member Not Found', self.errorToast)
                    }
                })
                .catch((handle) => {
                    self.$toasted.show(handle, self.errorToast);
                })
        },
        updateMember(member) {
            let self = this
            // let obj = Object.assign({}, member)
            // console.log("OBJ-----",obj)
            // obj.primary_country_code = member.phone[0].countryCode
            // obj.primary_mobile = member.phone[0].phone
            // obj.secondary_country_code = member.phone[1].countryCode
            // obj.secondary_mobile = member.phone[1].phone
            // delete obj.phone;
            // delete obj.updated_at;
            // delete obj.created_at;
            axios.post(Common.apiUrl + 'member/update', member)
                .then(res => {
                    if (res.data.flag) {
                        self.requestFlag ? self.$toasted.show('Member Added', self.successToast) :
                            self.$toasted.show('Member Updated', self.successToast);
                        // self.addEditFlag = false;
                        // self.editFlag = false;
                        // self.addMemberDialog = false;
                        self.cancelMemberDialog();
                        self.getMemberRequest();
                        self.getMemberDetails();
                        if (self.requestFlag) {
                            self.totalMemberReqCount--;
                            self.skip = self.memberRequest.length > 1 ? self.skip : self.skip - self.count;
                        }

                    }
                    else {
                        self.alertDialog = true;
                        self.msg = '';
                        self.msg = res.data.message;
                    }
                })
                .catch((handle) => {
                    // self.$toasted.show(handle, self.errorToast);
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = "Please fill valid details";
                })
        }
        ,
        openDelDialog(data) {
            let self = this;
            self.delDialog = true;
            self.delData = {};
            self.delData = data;
        },
        openDelReqDialog(data) {
            let self = this;
            self.delReqDialog = true;
            self.delData = {};
            self.delData = data;
        },
        deleteMember() {
            let self = this;
            let a = self.delData;
            const index = this.memberDetails.indexOf(a);
            var mid = this.memberDetails[index].member_id;
            axios.get(Common.apiUrl + 'member/delete/' + mid)
                .then(function (res) {
                    if (res.data.flag) {
                        self.$toasted.show('Member Deleted', self.successToast);
                        self.skip = self.memberDetails.length > 1 ? self.skip : self.skip - self.count;
                        self.getMemberDetails();
                        // self.memberDetails.splice(index, 1);
                        self.$forceUpdate()
                    }
                    else {
                        self.alertDialog = true;
                        self.msg = '';
                        self.msg = res.data.message;
                        // self.$toasted.show(res.data.message, self.errorToast);
                    }
                })
                .catch((handle) => {
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = handle;
                    // self.$toasted.show(handle, self.errorToast);
                });
            self.delDialog = false
        },
        deleteMemberRequest() {
            let self = this;
            let a = self.delData;
            const index = this.memberRequest.indexOf(a);
            var mid = this.memberRequest[index].member_id;
            axios.get(Common.apiUrl + 'member/delete/' + mid)
                .then(function (res) {
                    if (res.data.flag) {
                        self.$toasted.show('Member Deleted', self.successToast);
                        self.totalMemberReqCount--;
                        self.skip = self.memberRequest.length > 1 ? self.skip : self.skip - self.count;
                        self.getMemberRequest();
                        // self.memberRequest.splice(index, 1);
                        self.$forceUpdate()
                    }
                    else {
                        self.alertDialog = true;
                        self.msg = '';
                        self.msg = res.data.message;
                        // self.$toasted.show(res.data.message, self.errorToast);
                    }
                })
                .catch((handle) => {
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = handle;
                    // self.$toasted.show(handle, self.errorToast);
                });
            self.delReqDialog = false
        },
        redirectToAddNewMember() {
            let self = this;
            self.addEditFlag = false;
            self.addFlag = true;
            self.addMemberDialog = true
        },
        openEditDialog(data) {
            let self = this;
            self.editMember = data;
            self.editFlag = true;
            self.addEditFlag = true;
            self.addMemberDialog = true;
        }
        ,
        openDetailDialog(data) {
            let self = this;
            self.editMember = data;
            self.detailFlag = true;
            self.addMemberDialog = true;
        }
        ,
        openRequestDialog(data) {
            let self = this;
            self.editMember = data;
            self.editFlag = true;
            self.addEditFlag = true;
            self.requestFlag = true;
            self.addMemberDialog = true;
        }
        ,
        saveMember() {
            this.getMemberDetails();
            this.addMemberDialog = false;
        }
        ,
        cancelMemberDialog() {
            let self = this;
            self.addEditFlag = false;
            self.requestFlag = false;
            self.detailFlag = false;
            self.addFlag = false;
            self.editFlag = false;
            self.addMemberDialog = false;
        }
        ,

        importMember() {
            let self = this;
            let ele = document.getElementById("fileId");
            ele.value = '';
            self.memberFile = '';
            self.memberFileName = '';
            self.alertDialog = false;
            self.uploadBtnFlag = true;
            self.dialog = true;
        },
        pickFile() {
            let self = this;
            self.$refs.image.click()
            //  self.$refs.image.memberFileName[0];
        },
        onFilePicked(e) {
            let self = this;
            const files = e.target.files;
            if (files[0] !== undefined) {
                self.memberFileName = files[0].name;
                if (self.memberFileName.lastIndexOf('.') <= 0) {
                    return
                }
                const fr = new FileReader();
                fr.readAsDataURL(files[0]);
                fr.addEventListener('load', () => {
                    self.memberFile = files[0] // this is an image file that can be sent to server...
                })
            }
            this.uploadBtnFlag = false;
        },
        uploadMember() {
            let self = this;
            self.uploadBtnFlag = true;
            self.uploadProgressPopup = true;
            let formData = new FormData();
            formData.append('file', this.memberFile);
            formData.append('clubId', this.$route.params.id);
            axios.post(Common.apiUrl + 'member/upload/sheet', formData)
                .then(res => {
                    if (res.data.flag) {
                        self.successRecordArr = res.data.data.success;
                        self.failRecordArr = res.data.data.error;
                        self.uploadProgressPopup = false;
                        self.uploadStatusPopup = true;
                        self.dialog = false;
                        self.getMemberDetails();
                    } else {
                        self.msg = '';
                        self.uploadProgressPopup = false;
                        if (res.data.errors) {
                            self.successRecordArr = [];
                            self.failRecordArr = res.data.errors;
                            self.uploadStatusPopup = true;
                            self.getMemberDetails();
                            self.dialog = false;

                        } else if (res.data.data.errors) {
                            self.successRecordArr = [];
                            self.failRecordArr = res.data.data.errors;
                            self.uploadStatusPopup = true;
                            self.getMemberDetails();
                            self.dialog = false;

                        } else {
                            self.alertDialog = true;
                            self.msg = res.data.message;
                        }
                    }

                }).catch((handle) => {
                console.log("Error", handle)
                self.uploadProgressPopup = false;
                self.alertDialog = true;
                self.msg = '';
                self.msg = 'Please select a valid file'
            })
        },
        successUpload() {
            let self = this;
            self.$toasted.show("Uploaded Successfully", self.successToast);
        },
        cancelUpload() {
            let self = this;
            self.dialog = false;
        }
        ,
        goBack() {
            window.history.go(-1)
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Member/MemberDetails.js